import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  SkipSelf,
  ViewChild,
} from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { take } from 'rxjs';
// import moment from 'moment';

@Component({
  selector: 'app-expanding-text-area',
  templateUrl: './expanding-text-area.component.html',
  styleUrls: ['./expanding-text-area.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
})
export class ExpandingTextAreaComponent implements OnInit {
  constructor(private _ngZone: NgZone) {}

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  @Input() labelText = '';
  @Input() placeholder = '';
  @Input() minRows = 1;
  @Input() maxRows = 8;
  @Input() required = false;
  @Input() value = '';
  @Input() hint = '';
  @Output() change = new EventEmitter<string>();

  uuid = Math.floor(Math.random() * 9999).toString();

  ngOnInit(): void {
    if (this.value === undefined) this.value = '';
  }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable
      .pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  onChange(e: any) {
    this.change.emit(e.srcElement.value);
  }
}
